import { v4 as uuidv4 } from "uuid";

export const strengthScaleDragForArcteryx = {
    "blockId": uuidv4(),
    "goalId": "feedback360_strengthScaleDrag",
    "isHiddenFromEditSurvey": true,
    "totalRanking": 3,
    "questions": [
        {
            "question": "Build great teams and organizations",
            "type": "priorityDrag",
            "questionDimension": "Builds great teams and organizations"
        }
    ],
    "selfMainHeading": "<span><b>Strengths to Leverage Most: </b> These are the behaviors you identified as demonstrating most often (i.e., \"Often\" or \"Always\"). Please <b>rank the top 3</b> behaviors you should continue to lean on, given the organization's priorities and your role.</span>",
    "mainHeading": "<span><b>Strengths to Leverage Most: </b> These are the behaviors you identified as demonstrated most often (i.e., \"Often\" or \"Always\"). Please <b>rank the top 3</b> behaviors the person should continue to lean on, given the organization's priorities and the person's role.</span>",
    "instructionHeader": "DRAG AND DROP THE TOP 3 STRENGTHS TO LEVERAGE",
    "selfInstructionHeader": "DRAG AND DROP THE TOP 3 STRENGTHS TO LEVERAGE",
    "displayMappingLogic": "topicWise",
    "totalAnswersCount": 4,
    "type": "priorityDrag",
    "dimension": "Build great teams and organizations"
}


export const improvementScaleDragForArcteryx = {
    "blockId": uuidv4(),
    "goalId": "feedback360_improvementScaleDrag",
    "isHiddenFromEditSurvey": true,
    "totalRanking": 3,
    "selfMainHeading": "<span><b>Opportunities to Grow: </b>These are the behaviors you identified demonstrating less often (i.e., \"Never\", \"Rarely\", \"Occasionally\", \"Sometimes\"). Please <b>rank the top 3</b> that would have the greatest impact if strengthened, given the organization's priorities and your role.</span>",
    "mainHeading": "<span><b>Opportunities to Grow: </b>These are the behaviors you identified being demonstrated less often (i.e., \"Never\", \"Rarely\", \"Occasionally\", \"Sometimes\"). Please <b>rank the top 3</b> that would have the greatest impact if strengthened, given the organization's priorities and the person's role.</span>",
    "instructionHeader": "DRAG AND DROP THE TOP 3 DEVELOPMENT AREAS TO WORK ON",
    "selfInstructionHeader": "DRAG AND DROP THE TOP 3 DEVELOPMENT AREAS TO WORK ON",
    "questions": [
        {
            "question": "Build great teams and organizations",
            "type": "priorityDrag",
            "questionDimension": "Builds great teams and organizations"
        }
    ],
    "displayMappingLogic": "topicWise",
    "totalAnswersCount": 4,
    "type": "priorityDrag",
    "dimension": "Builds great teams and organizations"
}